import { FC } from 'react';

import { RelativeTime } from '@bonusly/common-relative-time';
import { RichTextDisplay } from '@bonusly/common-rich-text-editor';
import { Box, Flex, Spacer, StyleProps, Text, VStack } from '@bonusly/design-system';

import { parseDateSafely } from '../../../../utils/date';
import { ReactComponent as SummarizeOutline } from '../../assets/summarize-outline-icon.svg';
import { ReactComponent as TakeNoteOutline } from '../../assets/take-note-outline-icon.svg';

export interface TopicHistoryCardProps extends StyleProps {
	title: string;
	content: string;
	createdAt: string;
}

export const TopicHistoryCard: FC<TopicHistoryCardProps> = ({ title, content, createdAt, ...rest }) => {
	if (!content) return null;

	return (
		<Box bg="secondary.bgAlpha" p={3} borderRadius="md" mx="auto" sx={{ breakInside: 'avoid' }} data-component="goal-details-timeline-topic-card" {...rest}>
			<VStack gap={1} align="flex-start" justify="flex-start" width="full">
				<Flex alignItems="center" justifyContent="flex-start" gap={2} mb={1} direction="row" width="full">
					<Box bg="secondary.bgAlpha" borderRadius="full" color="text.softest" display="flex" alignItems="center" justifyContent="center" w={8} h={8}>
						{title === 'written' && <TakeNoteOutline />}
						{title === 'summary' && <SummarizeOutline />}
					</Box>
					<Text fontSize={50} fontWeight="semibold" color="text.softest">
						{title === 'written' && 'Notes from 1:1'}
						{title === 'summary' && 'Discussion summary'}
					</Text>
					<Spacer />
					<RelativeTime color="text.softest" date={parseDateSafely(createdAt)} fontSize="sm" />
				</Flex>

				<RichTextDisplay fontSize="sm">{content}</RichTextDisplay>
			</VStack>
		</Box>
	);
};
